import { render, staticRenderFns } from "./handlingCase.vue?vue&type=template&id=9f8b82c6&scoped=true&"
import script from "./handlingCase.vue?vue&type=script&lang=js&"
export * from "./handlingCase.vue?vue&type=script&lang=js&"
import style0 from "./handlingCase.vue?vue&type=style&index=0&id=9f8b82c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f8b82c6",
  null
  
)

export default component.exports